'use strict';

angular.module('inara').factory('SelectMenuPositionService', SelectMenuPositionService);

SelectMenuPositionService.$inject = ['$window', '$ionicPosition'];

function SelectMenuPositionService($window, $ionicPosition) {
	return {
		createPositionViewHandler: createPositionViewHandler
	};

	function createPositionViewHandler(dummyItemSelector, itemCount) {
		// All parameters are optional, but if you supply dummyItemSelector, 
		// you should also supply itemCount. These are used to supply an initial
		// height for the list item based on a dummy item height (determined by
		// the offsetHeight of the element returned by dummyItemSelector) times
		// the itemCount. This is useful if the select menu contents are 
		// based on ng-repeat, which won't be processed until after the view 
		// has initially rendered. If the parameters are omitted, no height 
		// calculation is done.
		var dummyItemHeight;
		return function(target, popoverEle) {
            if (dummyItemSelector && !dummyItemHeight) {
                var item = popoverEle[0].querySelector(dummyItemSelector);
                if (item !== null) {
                    dummyItemHeight = parseInt(angular.element(item).prop('offsetHeight'), 10);                    
                }
            }
            if (dummyItemHeight) {
                //log.debug('dummy item height = ' + dummyItemHeight);
                var list = angular.element(popoverEle[0].querySelector('ion-list > .list'));
                list.css('height', dummyItemHeight * (itemCount ? itemCount : 0) + 'px');
                //log.debug('popover height = ' + popoverEle.prop('offsetHeight'));
            }
            positionView(target, popoverEle);
		};
	}

	function positionView(target, popoverEle) {
	    // Adapted from $ionicPopover source
	    var POPOVER_BODY_PADDING = 6;
	    var targetEle = angular.element(target.target || target);
	    var buttonOffset = $ionicPosition.offset(targetEle);
	    var popoverWidth = popoverEle.prop('offsetWidth');
	    var popoverHeight = popoverEle.prop('offsetHeight');
	    // Use innerWidth and innerHeight, because clientWidth and clientHeight
	    // doesn't work consistently for body on all platforms
	    var bodyWidth = $window.innerWidth;
	    var bodyHeight = $window.innerHeight;

	    var popoverCSS = {
	        left: buttonOffset.left
	    };
	    var arrowEle = angular.element(popoverEle[0].querySelector('.popover-arrow'));

	    if (popoverCSS.left < POPOVER_BODY_PADDING) {
	        popoverCSS.left = POPOVER_BODY_PADDING;
	    } else if (popoverCSS.left + popoverWidth + POPOVER_BODY_PADDING > bodyWidth) {
	        popoverCSS.left = bodyWidth - popoverWidth - POPOVER_BODY_PADDING;
	    }

	    // If the popover when popped down stretches past bottom of screen,
	    // make it pop up.
	    if (buttonOffset.top + popoverHeight > bodyHeight) {
	        popoverCSS.top = buttonOffset.top + buttonOffset.height - popoverHeight;
	        if (popoverCSS.top < 0) popoverCSS.top = 0;
	        popoverEle.removeClass('popover-bottom');
	    } else {
	        popoverCSS.top = buttonOffset.top;
	        popoverEle.addClass('popover-bottom');
	    }

	    arrowEle.css({
	        left: buttonOffset.left + buttonOffset.width / 2 -
	        arrowEle.prop('offsetWidth') / 2 - popoverCSS.left + 'px'
	    });

	    popoverEle.css({
	        top: popoverCSS.top + 'px',
	        left: popoverCSS.left + 'px',
	        marginLeft: '0',
	        opacity: '1'
	    });
	}
}

module.exports = SelectMenuPositionService;
